import { Typography } from '@material-ui/core';
import * as React from 'react';
import { useEffect } from 'react';
import { PieChart } from '../../../../../components/muiLegacy/Charts/PieChart';
import { AnalysisChartLoading } from '../../../AnalysisChartLoading';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import { ChartProps } from '../../../AnalysisList';
import { internationalText } from '../../../internationalText';
import DataTimedOut, { didQueryTimeout } from '../../DataTimedOut';
import NotEnoughData from '../../NotEnoughData';
import { segmentNameInterval, wordCountIntervals } from './HBLtChartByTopic.logic';

export interface HBLtPieChartProps extends ChartProps { }

const HBLtPieChart: React.FC<HBLtPieChartProps> = ({
  project,
  setAnalysisFilterState,
  analysisFilterState,
  language,
  palette,
}) => {
  // Adjust shown filters
  useEffect(
    () =>
      setAnalysisFilterState((prev) => ({
        ...prev,
        shownFields: {
          showSerpOnly: true,
          showHBLt: true,
          showTagGroupId: true,
          showTagId: true,
        },
      })),
    []
  );

  // Fetch data
  const { result, query } = projectsApiService.queries.analysis.useGetHBLt({
    projectId: project.id,
    wordCountIntervals: wordCountIntervals(analysisFilterState, language),
    serpFilter: analysisFilterState?.serpOnly,
    tagGroupId: analysisFilterState?.tagGroupId,
    tagId: analysisFilterState?.tagId,
  });

  const data = result?.hBLtAnalyses
    ?.map((x) => ({
      id:
        x.name +
        ' (' +
        segmentNameInterval(x.startCount, x.endCount) +
        (x.endCount === 1
          ? ` ${internationalText.chart.keyword_specificity.word[language]})`
          : ` ${internationalText.chart.keyword_specificity.words[language]})`),
      value: x.searchVolume,
    }));

  // Render
  if (didQueryTimeout(query)) {
    return <DataTimedOut />;
  }

  if (query?.loading) {
    return <AnalysisChartLoading />;
  }

  if (!(result?.hBLtAnalyses.map((x) => x.searchVolume).reduce((a, b) => a + b, 0) > 0)) {
    return <NotEnoughData />;
  }

  return (
    <div>
      <PieChart data={data} valueForm={' ^-.2~s'} colors="standard" palette={palette} />
      <Typography variant="caption" display="block" align="center">
        {internationalText.chart.keyword_specificity.head_desc[language]}
      </Typography>
      <Typography variant="caption" display="block" align="center">
        {internationalText.chart.keyword_specificity.body_desc[language]}
      </Typography>
      <Typography variant="caption" display="block" align="center">
        {internationalText.chart.keyword_specificity.longtail_desc[language]}
      </Typography>
    </div>
  );
};

export default HBLtPieChart;
